export enum ActivityTypeEnum {
  ACTIVITY_SHEET = 'ACTIVITY_SHEET',
  DUE_PAYMENT = 'DUE_PAYMENT',
  ON_CALL = 'ON_CALL',
  FEE = 'FEE',
  REGULATION = 'REGULATION'
}
